'use client';

import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import StopRoundedIcon from '@mui/icons-material/StopRounded';
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Tooltip,
  type SxProps,
} from '@mui/material';
import { flatSx, StackRow } from '@ocodelib/mui';
import { useObservable } from '@ocodelib/mui/hooks';
import clsx from 'clsx';
import { IframeMonacoEditorWrapper } from '../iframes';
import { usePyBasicApp } from '../usePyBasicApp';

interface Props {
  sx?: SxProps;
  className?: string;
}

export function CodeEditorContainer(props: Props) {
  const { className, sx } = props;
  const { app, appManager } = usePyBasicApp();
  const datiBaseURL = appManager.appConfig.datiBaseURL;

  return (
    <Box
      className={clsx('CodeEditorContainer-root', className)}
      sx={flatSx(
        {
          position: 'relative',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          '& .CodeEditorContainer-editor': {
            width: '100%',
            height: '100%',
          },
        },
        sx,
      )}
    >
      <CodeEditorTop />

      <IframeMonacoEditorWrapper
        className="CodeEditorContainer-editor"
        datiBaseURL={datiBaseURL}
        onLoadEditor={(editor) => {
          app.setupCodeEditor(editor);
        }}
      />
    </Box>
  );
}

function CodeEditorTop() {
  const { app } = usePyBasicApp();
  const editor = useObservable(app?.editor$);
  const autoRefreshEnabled = useObservable(app?.autoRefreshEnabled$);

  const handleClickPlay = () => {
    if (!app) return;
    app.runCurrentCode();
  };

  const handleClickStop = () => {
    if (!app) return;
    app.stopExecuting();
  };

  return (
    <Box
      sx={{
        bgcolor: '#edeff1',
        height: 40,
        pl: 1,
        pr: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        borderLeft: '1px solid #ccc',
      }}
    >
      {editor && (
        <StackRow ml="auto" alignItems="center" spacing={0.5}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={autoRefreshEnabled ?? false}
                  onChange={(_, checked) => {
                    app?.setAutoRefreshEnabled(checked);
                  }}
                  size="small"
                />
              }
              label="자동 실행"
            />
          </FormGroup>
          <Tooltip title="Run">
            <IconButton onClick={handleClickPlay} color="secondary" size="small">
              <PlayArrowRoundedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Stop">
            <IconButton onClick={handleClickStop} color="primary" size="small">
              <StopRoundedIcon />
            </IconButton>
          </Tooltip>
        </StackRow>
      )}
    </Box>
  );
}
